import React, { memo } from 'react';

import { Box } from '@mui/material';
import AccordionCDS from '@sharedCR/coreDesignSystem/AccordionCDS';
import { TableCDS } from '@sharedCR/coreDesignSystem/Table';
import PropTypes from 'prop-types';

import { EARLIER_REASONS_TITLE } from '../../LoanCicHistory.constants';
import { LoanCicHistoryTestIds } from '../../LoanCicHistory.testIds';

import {
  CIC_EARLIER_REASONS_TABLE_CONFIG,
  EARLIER_REASONS_SUMMARY,
} from './CicEarlierReasons.config';
import { accordionStyles, wrapperStyles } from './CicEarlierReasons.styles';

const CicEarlierReasons = ({ earlier }) => (
  <Box data-testid={LoanCicHistoryTestIds.EARLIER_REASONS} sx={wrapperStyles}>
    <AccordionCDS
      additionalSummaryContent={EARLIER_REASONS_SUMMARY}
      arrowSize={16}
      className=""
      customStyles={accordionStyles}
      title={`${EARLIER_REASONS_TITLE} (${earlier.length})`}
      titleVariant="bold14"
    >
      <TableCDS config={CIC_EARLIER_REASONS_TABLE_CONFIG} data={earlier} />
    </AccordionCDS>
  </Box>
);

CicEarlierReasons.propTypes = {
  earlier: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      reasonName: PropTypes.string,
      comment: PropTypes.string,
      fields: PropTypes.arrayOf(PropTypes.string),
      addedByName: PropTypes.string,
      addedDate: PropTypes.string,
    }),
  ).isRequired,
};

export default memo(CicEarlierReasons);
